var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupfilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2535_189451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 0H3.9375C1.76288 0 0 1.76288 0 3.9375V14.0625C0 16.2371 1.76288 18 3.9375 18H14.0625C16.2371 18 18 16.2371 18 14.0625V3.9375C18 1.76288 16.2371 0 14.0625 0ZM16.875 14.0625C16.875 15.6158 15.6158 16.875 14.0625 16.875H3.9375C2.38419 16.875 1.125 15.6158 1.125 14.0625V3.9375C1.125 2.38419 2.38419 1.125 3.9375 1.125H14.0625C15.6158 1.125 16.875 2.38419 16.875 3.9375V14.0625Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 3.9375H4.5C4.18932 3.9375 3.9375 4.18932 3.9375 4.5V5.625C3.9375 5.93568 4.18932 6.1875 4.5 6.1875H5.625C5.93568 6.1875 6.1875 5.93568 6.1875 5.625V4.5C6.1875 4.18932 5.93568 3.9375 5.625 3.9375Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 7.875H4.5C4.18932 7.875 3.9375 8.12682 3.9375 8.4375V9.5625C3.9375 9.87318 4.18932 10.125 4.5 10.125H5.625C5.93568 10.125 6.1875 9.87318 6.1875 9.5625V8.4375C6.1875 8.12682 5.93568 7.875 5.625 7.875Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 11.8125H4.5C4.18932 11.8125 3.9375 12.0643 3.9375 12.375V13.5C3.9375 13.8107 4.18932 14.0625 4.5 14.0625H5.625C5.93568 14.0625 6.1875 13.8107 6.1875 13.5V12.375C6.1875 12.0643 5.93568 11.8125 5.625 11.8125Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 4.5H7.3125V5.625H14.0625V4.5Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 8.4375H7.3125V9.5625H14.0625V8.4375Z",
    fill: "#5C5C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 12.375H7.3125V13.5H14.0625V12.375Z",
    fill: "#5C5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2535_189451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupfilterIcon);
export default __webpack_public_path__ + "static/media/groupfilter-icon.cf54f679d3ab6e78d81b7083fc07ca7c.svg";
export { ForwardRef as ReactComponent };